import React, { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import {
    BoxTitle,
    BoxContainer,
    BoxHead,
    Underline,
    FilterTableWrapper,
    FilterWrapper,
} from "../../Components/Styles/PageStyles";
import { useSelector } from "react-redux";
import moment from "moment";
import NotFoundModel from "../../Components/NotFoundModel";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import RefundTable from "../../Components/Transactions/RefundTable";

const Refund = () => {
    const searchOptions = [
        { label: "Mobile", value: 1 },
        { label: "Name", value: 2 },
    ];
    const [previousStartDate, setPreviousStartDate] = useState(
        moment().startOf("month").format("YYYY-MM-DD")
    );
    const [previousEndDate, setPreviousEndDate] = useState(
        moment(new Date()).format("YYYY-MM-DD")
    );

    const [startDate, setStartDate] = useState(previousStartDate);
    const [endDate, setEndDate] = useState(previousEndDate);
    const [filterType, setFilterType] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isFirstTime, setIsFirstTime] = useState(true);
    const user = useSelector((state) => state.UserReducer.user);

    const [isFocused, setIsFocused] = useState(false);
    const [selectedData, setSelectedData] = useState("");
    const [apiData, setApiData] = useState();
    const [masterData, setMasterData] = useState();

    const query = `startDate=${startDate}&endDate=${endDate}&s=${searchQuery}&t=${filterType}`;

    const fetchFunction = async () => {
        const response = await axios.get(
            `${Config.apiUrl}/transaction/get/refund/records?${query}`,
            {
                headers: {
                    authorization: "Bearer" + " " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess === true) {
            setApiData(res?.list);
            setMasterData(res?.list);
            // if (isFocused === false) setSummaryData(res?.stats);
            setIsFocused(true);
        } else {
            error = true;
        }
    };

    const getError = (res) => { };

    const {
        isLoading: isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
        isFetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });
    useEffect(() => {
        setIsFirstTime(false);
        getListMutate();
    }, []);
    useEffect(() => {
        if (!isFirstTime && !isFetching && !isRefetching && !isLoading) {
            sessionStorage.removeItem("tenant_refund_page");
            const handler = setTimeout(() => {
                getListMutate();
            }, 100);

            return () => {
                clearTimeout(handler);
            };
        }
    }, [startDate, endDate, filterType, searchQuery]);

    const handleFilterChange = (values) => {
        setFilterType(values.filterType);
        setSearchQuery(values.searchQuery);
    };

    const handleClearFilters = () => {
        setFilterType("");
        setSearchQuery("");
        setStartDate(previousStartDate);
        setEndDate(previousEndDate);

    };

    const getDateRangeDisplayText = () => {
        if (
            startDate &&
            endDate &&
            moment(startDate).isValid() &&
            moment(endDate).isValid()
        ) {
            return (
                moment(startDate).format("DD MMM yyyy") +
                " - " +
                moment(endDate).format("DD MMM yyyy")
            );
        }
        return "Select Date Range";
    };

    const submitHandler = (values) => {
        const newValues = {
            startDate: moment(values.startDate).format("YYYY-MM-DD"),
            endDate: moment(values.endDate).format("YYYY-MM-DD"),
        };
        setStartDate(newValues.startDate);
        setEndDate(newValues.endDate);
        setPreviousStartDate(newValues.startDate);
        setPreviousEndDate(newValues.endDate);
    };



    return (
        <>
            <BoxContainer>
                <BoxHead>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        Refunds
                        <Underline />
                    </BoxTitle>
                    <DateRange
                        submitHandler={submitHandler}
                        defaultLabel={getDateRangeDisplayText()}
                        className="flex-1 min-w-0"
                    />
                </BoxHead>

                <FilterTableWrapper >
                    <FilterWrapper className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* <TotalDues> */}
                        {/* <Text>
                            Total refund amount ₹{data?.refundedAmount || 0}
                        </Text> */}
                        {/* </TotalDues> */}
                        <div className="flex items-center">
                            <Text>
                                Total refund amount:{" "}
                                <span className="font-semibold">
                                    {data?.refundedAmount || 0}
                                </span>
                            </Text>
                        </div>

                    </FilterWrapper>
                    {!error && !isLoading && apiData && (
                        <TableWrapper tab="2">
                            <RefundTable
                                apiData={error ? [] : apiData?.length > 0 ? apiData : []}
                                setSelectedData={setSelectedData}
                                selectedData={selectedData}
                            />
                            {(error || apiData.length === 0) && !isLoading && <NotFoundModel msg={"No Data found."} />}
                        </TableWrapper>
                    )}
                </FilterTableWrapper>

                {(isLoading || isRefetching) && <Loading />}
                {error && !isLoading && <NotFoundModel />}
            </BoxContainer>
        </>
    );
};


const TableWrapper = tw.h1`
  bg-white rounded-md 
  ${props => props.tab === "1" ? "mt-2" : "mt-4"}
`;
// const TotalDues = tw.div`bg-green-100 px-4 py-2 items-center rounded-br-lg lg:mb-20 xl:mb-6 mb-2`;
const TotalDues = tw.div`bg-green-100 px-4 py-2 items-center rounded-br-lg `;
const Text = tw.p`text-gray-500 text-sm font-normal`;

export default Refund;